export default "__VITE_ASSET__LGmzukga__"